import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Inject,
  inject,
} from '@angular/core';
import { AppConfig, APP_CONFIG } from '@cardapio-online/config';
import { BrandKernelService } from '@cardapio-online/theme';

@Component({
  selector: 'lib-shell-footer',
  templateUrl: './shell-footer.component.html',
  styleUrl: './shell-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellFooterComponent {
  protected readonly brand = inject(BrandKernelService);

  protected readonly whatsappUrl = computed(() => {
    const wa = this.brand.companyContact()?.whatsapp;
    if (!wa) return null;
    return `https://wa.me/55${wa.replace(/\D/g, '')}`;
  });

  protected readonly formattedAddress = computed(() => {
    const addr = this.brand.companyAddress();
    if (!addr) return null;
    return [addr.city, addr.state].filter(Boolean).join(', ') || null;
  });

  protected readonly instagramUrl = computed(() => {
    const handle = this.brand.companyContact()?.instagram;
    if (!handle) return null;
    return `https://instagram.com/${handle.replace('@', '')}`;
  });

  constructor(@Inject(APP_CONFIG) protected readonly cfg: AppConfig) {}

  get year(): number {
    return new Date().getFullYear();
  }

  protected formatPhone(raw: string): string {
    const d = raw.replace(/\D/g, '');
    if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
    if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
    return raw;
  }
}
